/* eslint-disable consistent-return */
import { createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { setIsSpinnerVisible } from "store/modules/AppConfig/index.store";

import DealerCare from "services/dealerCareApi";
import Billing from "services/billingApi";

import {
  UpdateDealerRequestProps,
  DealerSearchByIdResponse,
  DealerSearchByIdRequest,
  UpdateDealerCareDetailsRequest,
} from "./types.store";

export const handleSearchDealerByIdRequest = createAsyncThunk<
  DealerSearchByIdResponse,
  DealerSearchByIdRequest
>("getSearchDealer", async (params, { rejectWithValue, dispatch }) => {
  try {
    dispatch(setIsSpinnerVisible(true));

    const dealerInfo = await DealerCare.get(`/v1/dealers/${params.dealerId}`);
    const dealerPaymentMethods = await Billing.get(
      `/v2/dealers/${params.dealerId}/paymentmethods-all-origins`,
    );

    return {
      dealerInfo: dealerInfo.data.data,
      paymentMethods: dealerPaymentMethods.data,
    };
  } catch (err) {
    toast("Falha ao carregar revenda, tente novamente!", {
      type: "error",
      autoClose: false,
    });

    if (Axios.isAxiosError(err) && err && err.response) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err);
  } finally {
    dispatch(setIsSpinnerVisible(false));
  }
});

export const handleUpdateDealerRequest = createAsyncThunk<
  void,
  UpdateDealerRequestProps
>("postPutUpdateDealer", async (params, { rejectWithValue, dispatch }) => {
  try {
    dispatch(setIsSpinnerVisible(true));

    await Billing.post(
      `/v2/dealers/${params.dealerId}/paymentmethods`,
      params.methodsPayments,
    );
  } catch (err) {
    toast("Falha ao atualizar os dados da revenda, tente novamente!", {
      type: "error",
      autoClose: false,
    });

    if (Axios.isAxiosError(err) && err && err.response) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err);
  } finally {
    dispatch(setIsSpinnerVisible(false));
  }
});

export const handleUpdateDealerCareDetailsRequest = createAsyncThunk<
  null,
  UpdateDealerCareDetailsRequest
>("updateDealerCareDetails", async (params, { rejectWithValue, dispatch }) => {
  try {
    dispatch(setIsSpinnerVisible(true));

    await DealerCare.put(`/v1/dealers/${params.dealerId}/details`, {
      ...params,
    });
    return null;
  } catch (err) {
    if (Axios.isAxiosError(err) && err && err.response) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err);
  } finally {
    dispatch(setIsSpinnerVisible(false));
  }
});
